import Localbase from 'localbase';

export const db = new Localbase('db');

db.config.debug = false;
